/**
 * MobileMenu for lbbw-am.de
 *
 * @author Florian Gutwald
 * Converted to Plain JS for Rollup
 */
export default class MobileMenu {
  /**
   * MobileMenu constructor
   *
   * @param {HTMLElement} element - The main navigation container
   */
  constructor(element) {
    this.element = element;
    this.body = document.body;
    this.events = new AbortController();
    this.mainmenuLayer = document.getElementById('mainmenu_layer');
    this.menuToggle = document.getElementById('mainmenu_toggle');

    if (!this.mainmenuLayer || !this.menuToggle) {
      console.warn('MobileMenu: Required elements not found');
      return;
    }

    this.init();
  }

  /**
   * Initialize the mobile menu
   */
  init() {
    this.mainmenuLayer.querySelectorAll('.flyout-menu-item-link').forEach(link => link.removeAttribute('tabindex'));
    this.attachToggleHandler();
    this.attachNavlinkHandler();
    this.attachBackHandler();
  }

  /**
   * Handle mobile menu toggle button
   */
  attachToggleHandler() {
    this.menuToggle.addEventListener('click', () => {
      const isOpen = this.body.classList.contains('openflyout');

      if (!isOpen) {
        // Open menu
        this.body.classList.add('openflyout');
        this.mainmenuLayer.classList.add('mainmenu-layer__open');
        this.menuToggle.classList.add('mainmenu-trigger__active');
        this.menuToggle.classList.add('lbbw-icf--close');
        this.menuToggle.setAttribute('aria-expanded', 'true');

        // Reset all navlinks and flyouts
        this.mainmenuLayer.querySelectorAll('.navlink').forEach(link => {
          link.classList.remove('navlink__back');
        });
        this.mainmenuLayer.querySelectorAll('.flyout').forEach(flyout => {
          flyout.classList.remove('flyout__active');
        });
      } else {
        // Close menu
        this.closeMenu();
      }
    }, { signal: this.events.signal });
  }

  /**
   * Handle navigation link clicks (level down)
   */
  attachNavlinkHandler() {
    document.addEventListener('click', (event) => {
      const navlink = event.target.closest('.navlink:not(.navlink__back)');
      if (!navlink) return;

      // Check if this navlink has a flyout sibling
      const flyout = navlink.nextElementSibling;
      if (!flyout || !flyout.classList.contains('flyout')) return;

      event.preventDefault();

      const listItem = navlink.parentElement;
      listItem.classList.add('active');
      flyout.classList.add('flyout__active');

      // Add back class after animation
      setTimeout(() => {
        if (!this.events.signal.aborted) navlink.classList.add('navlink__back');
      }, 600);
    }, { signal: this.events.signal });
  }

  /**
   * Handle back button clicks (level up)
   */
  attachBackHandler() {
    document.addEventListener('click', (event) => {
      const backLink = event.target.closest('.navlink__back');
      if (!backLink) return;

      event.preventDefault();

      const listItem = backLink.parentElement;
      const flyout = backLink.nextElementSibling;

      backLink.classList.remove('navlink__back');
      listItem.classList.remove('active');

      if (flyout && flyout.classList.contains('flyout')) {
        flyout.classList.remove('flyout__active');
      }
    }, { signal: this.events.signal });
  }

  /**
   * Close the mobile menu
   */
  closeMenu() {
    this.body.classList.remove('openflyout');
    this.mainmenuLayer.classList.remove('mainmenu-layer__open');
    this.menuToggle.classList.remove('mainmenu-trigger__active');
    this.menuToggle.classList.remove('lbbw-icf--close');
    this.menuToggle.setAttribute('aria-expanded', 'false');

    // Reset all states
    this.mainmenuLayer.querySelectorAll('.navlink__back').forEach(link => {
      link.classList.remove('navlink__back');
    });
    this.mainmenuLayer.querySelectorAll('.flyout__active').forEach(flyout => {
      flyout.classList.remove('flyout__active');
    });
    this.mainmenuLayer.querySelectorAll('.active').forEach(item => {
      item.classList.remove('active');
    });
  }

  /**
   * Destroy the mobile menu (cleanup)
   */
  destroy() {
    this.events.abort();
    if (this.mainmenuLayer && this.menuToggle) this.closeMenu();
  }
}
